import { TextArea } from 'design-system-web';

/**
 * @deprecated Import from design-system-web instead
 */
export default TextArea;
